import { render } from "./ProfileNavigation.vue?vue&type=template&id=d7502902&scoped=true"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js"

import "./ProfileNavigation.vue?vue&type=style&index=0&id=d7502902&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7502902"]])

export default __exports__